<template lang="pug">
.package-container
  //- v-bind:style="{ 'min-height': type=='container' ? (95 * pages.pageData.length)+ 'px !important' : (77 * pages.pageData.length) + 'px !important' }"
  .element-container(v-for="(element, index) in pages.pageData" v-if="type=='car'" :key="index")
    .d-flex.justify-content-end.w-100(style="margin-bottom: -39px; margin-top: 15px;" :class="{ 'selected-item': selected==element}")
      <svg class="infos-icon" @click="develop(element)" v-if="selected==element" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g class="icon-path" fill="#333333"><path d="M86,157.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667zM86,78.83333l-35.83333,28.66667v-21.5l35.83333,-28.66667l35.83333,28.66667v21.5z"></path></g></g></svg>
      <svg class="infos-icon" @click="develop(element)" v-b-tooltip.hover :title="$t('packages.dimensions')" v-if="selected!=element" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g class="icon-path" fill="#333333"><path d="M14.33333,86c0,39.5815 32.08517,71.66667 71.66667,71.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667zM121.83333,64.5v21.5l-35.83333,28.66667l-35.83333,-28.66667v-21.5l35.83333,28.66667z"></path></g></g></svg>
    .d-flex
      .title.mr-1 {{ $t('packages.type') | dots($i18n.locale) }}
      .value.mr-1 {{ element.brand + ' ' + $t(`addTransit.config.carTypes.${element.type}`) + ' ' }}
    .d-flex
      .title.mr-1 {{ $t('packages.model') | dots($i18n.locale) }}
      .value.mr-1 {{ element.model + ' ' + element.version }}
    .d-flex
      .title.mr-1 {{ $t('transit.dimensions.amount') | dots($i18n.locale) }}
      .value.mr-1 {{ element.amount }}
    TransitionExpand
      .d-flex.flex-wrap(v-if="selected==element && carVersion(element)")
        .d-flex.dim-style(v-if="carVersion(element).longueur")
          .title.mr-1 {{ $t('addTransit.config.carDim.length') }}
          .value.mr-1 {{ carVersion(element).longueur }}
        .d-flex.dim-style(v-if="carVersion(element).largeur")
          .title.mr-1 {{ $t('addTransit.config.carDim.width') }}
          .value.mr-1 {{ carVersion(element).largeur }}
        .d-flex.dim-style(v-if="carVersion(element).hauteur")
          .title.mr-1 {{ $t('addTransit.config.carDim.height') }}
          .value.mr-1 {{ carVersion(element).hauteur }}
        .d-flex.dim-style(v-if="carVersion(element).poids_brut")
          .title.mr-1 {{ $t('addTransit.config.carDim.weight') }}
          .value.mr-1 {{ carVersion(element).poids_brut }}  


  .d-flex.flex-wrap.element-container(v-for="(element, index) in pages.pageData" v-if="type=='container'" :key="index")
    .d-flex.justify-content-end.w-100(style="margin-bottom: -39px; margin-top: 15px;" v-if="containerCapacity(element)"  :class="{ 'selected-item': selected==element}")
      <svg class="infos-icon" @click="develop(element)" v-if="selected==element" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g class="icon-path" fill="#333333"><path d="M86,157.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667zM86,78.83333l-35.83333,28.66667v-21.5l35.83333,-28.66667l35.83333,28.66667v21.5z"></path></g></g></svg>
      <svg class="infos-icon" @click="develop(element)" v-b-tooltip.hover :title="$t('packages.dimensions')" v-if="selected!=element" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g class="icon-path" fill="#333333"><path d="M14.33333,86c0,39.5815 32.08517,71.66667 71.66667,71.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667zM121.83333,64.5v21.5l-35.83333,28.66667l-35.83333,-28.66667v-21.5l35.83333,28.66667z"></path></g></g></svg>
    .d-flex.line-info
      .title.mr-1 {{ $t('addTransit.config.select.type_c') | dots($i18n.locale)  }}
      .value.mr-1 {{ $t(`addTransit.config.select.typesC.${element.type}`) }}
    .d-flex.line-info(v-if="element.particularity")
      .title.mr-1 {{ $t('addTransit.config.select.particularity') | dots($i18n.locale)  }}
      .value.mr-1 {{ $t(`addTransit.config.containerPart.${element.particularity}` ) }}
    .d-flex.line-info
      .title.mr-1 {{ $t('addTransit.config.select.capacity') | dots($i18n.locale)  }}
      .value.mr-1 {{ $t(`addTransit.config.containerCapacity.${element.capacity}` ) }}
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.weight') | dots($i18n.locale)  }}
      .value.mr-1 {{ element.weight }} Kg
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.amount') | dots($i18n.locale)  }}
      .value.mr-1 {{ element.amount }} C
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.value') | dots($i18n.locale)  }}
      .value.mr-1 {{ element.value }} €
    .d-flex.line-info(v-if="element.nature")
      .title.mr-1 {{ $t('transit.dimensions.desc') | dots($i18n.locale)  }}
      .value.mr-1.nature-info {{ element.nature }}
    TransitionExpand
      .d-flex.flex-wrap.w-100(v-if="selected==element")
        b-row.w-100.m-0.mt-2.cap-title(v-if="containerCapacity(element)")
          b-col.p-0(md="12")
            span {{ $t('addTransit.config.containerCap.cap', { val: containerCapacity(element)[element.capacity].m3 }) }}
        b-row.w-100.m-0.cap-content(v-if="containerCapacity(element)")
          b-col.d-flex.flex-column.p-0.w-50(md="6")
            span.cap-sub-title {{ $t('addTransit.config.containerCap.in') }}
            span.pl-1.pb-1 {{ $t('addTransit.config.containerCap.length', { val: containerCapacity(element)[element.capacity].in.length }) }}
            span.pl-1.pb-1 {{ $t('addTransit.config.containerCap.width', { val: containerCapacity(element)[element.capacity].in.width }) }}
            span.pl-1.pb-1 {{ $t('addTransit.config.containerCap.height', { val: containerCapacity(element)[element.capacity].in.height }) }}
          b-col.d-flex.flex-column.p-0.w-50(md="6")
            span.cap-sub-title {{ $t('addTransit.config.containerCap.out') }}
            span.pl-1.pb-1 {{ $t('addTransit.config.containerCap.length', { val: containerCapacity(element)[element.capacity].out.length }) }}
            span.pl-1.pb-1 {{ $t('addTransit.config.containerCap.width', { val: containerCapacity(element)[element.capacity].out.width }) }}
            span.pl-1.pb-1 {{ $t('addTransit.config.containerCap.height', { val: containerCapacity(element)[element.capacity].out.height }) }}


  .d-flex.flex-wrap.element-container(v-for="(element, index) in pages.pageData" v-if="type=='parcel'" :key="index")
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.weight') | dots($i18n.locale)  }}
      .value.mr-1 {{element.weight}} kg
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.length') | dots($i18n.locale)  }}
      .value.mr-1 {{element.length}} cm
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.width') | dots($i18n.locale)  }}
      .value.mr-1 {{element.width}} cm
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.height') | dots($i18n.locale)  }}
      .value.mr-1 {{element.height}} cm
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.amount') | dots($i18n.locale)  }}
      .value.mr-1 {{element.amount}} Pcs
    .d-flex.line-info
      .title.mr-1 {{ $t('transit.dimensions.value') | dots($i18n.locale)  }}
      .value.mr-1 {{element.value}} €
    .d-flex.line-info(v-if="element.nature")
      .title.mr-1 {{ $t('transit.dimensions.desc') | dots($i18n.locale)  }}
      .value.mr-1.nature-info {{ element.nature }}
  
  
  .d-flex.flex-wrap.element-container(v-for="(element, index) in pages.pageData" v-if="type=='publication'" :key="index")
    .d-flex.line-info
      .title.mr-1 {{ $t('publication.dimensions.weight') | dots($i18n.locale)  }}
      .value.mr-1 {{element.weight}} kg
    .d-flex.line-info(v-if="element.weightLeft")
      .title.mr-1 {{ $t('publication.dimensions.weightLeft') | dots($i18n.locale)  }}
      .value.mr-1 {{element.weightLeft}} kg
    .d-flex.line-info
      .title.mr-1 {{ $t('publication.dimensions.amount') | dots($i18n.locale)  }}
      .value.mr-1 {{element.priceweight}} €
    .d-flex.line-info(v-if="element.transportType")
      .title.mr-1 {{ $t('publication.transport') | dots($i18n.locale)  }}
      .value.mr-1.nature-info {{ element.transportType }}

  Paginator.col-12( v-if="pages.nbPages>1" :nbPages='pages.nbPages' :cuerentPage='pages.cuerentPage' @previous='preivousPage' @next='nextPage' @find='findPage')
</template>

<script>

import TransitionExpand from "@/components/ui/TransitionExpand";
import allCars from "@/views/Client/all_cars_models";
import containers from "@/views/Client/containers_model";
export default {
  name: 'Package',
  components: {
    TransitionExpand,
  },
  props: {
    contents: Array,
    type: String,
  },
  data() {
    return {
      selected: false,
      carsList : null,
      pages:{
        nbPages : 1,
        cuerentPage : 1,
        pageSize: 3,
        pageData : [],
      },
    };
  },
  mounted() {
    this.paginated();
    this.develop(this.pages.pageData[0]);
  },
  computed: {
    indexStart() {
      return (this.pages.cuerentPage - 1) * this.pages.pageSize;
    },
    indexEnd() {
      return this.indexStart + this.pages.pageSize;
    },
  },
  methods: {
    develop(selected){
      this.selected = (this.selected == selected) ? null : selected
    },
    carVersion(c) {
      this.carsList = c.type ? allCars[c.type] : [];
      if(this.carsList[c.brand]){
      const index = this.carsList[c.brand][c.model].findIndex(object => {
          return object.version == c.version;
      });
      return this.carsList[c.brand][c.model][index]
      } 
    },
    containerCapacity(container) {
      return container.type
        ? container.type !== "particular"
          ? containers[container.type][container.type]
          : container.particularity
          ? containers[container.type][container.particularity.code]
          : null
        : null;
    },
    paginated() {
      this.selected = null;
      this.pages.nbPages =
        this.contents &&
        this.contents.length > this.pages.pageSize
          ? Math.ceil(this.contents.length / this.pages.pageSize)
          : 1;
      this.contents
        ? (this.pages.pageData = this.contents.slice(
            this.indexStart,
            this.indexEnd
          ))
        : (this.pages.pageData = [],console.log('emptydata'));
    },
    nextPage() {
      if (this.pages.cuerentPage < this.pages.nbPages) {
        this.pages.cuerentPage++;
        this.paginated();
      }
    },
    preivousPage() {
      if (this.pages.cuerentPage > 1) {
        this.pages.cuerentPage--;
        this.paginated();
      }
    },
    findPage(i) {
      this.pages.cuerentPage = i;
      this.paginated();
    },
  },
};
</script>
<style>
.package-container{
  min-height: 77px;
}
.element-container{
  padding: 7px 8px;
  /* background-color: #fcfcfc; */
  border: 1px solid;
  border-bottom: 2px solid;
  border-color: #ededed;
  border-radius: 6px;
  margin-bottom: 5px;
}
.infos-icon{
  cursor: pointer;
  z-index: 1;
}
.icon-path{
  fill : #e1e1e1;
  transition: all 0.3s;
}
.element-container:hover .icon-path{
  fill : #333333;
  transition: all 0.3s;
}
.infos-icon:hover .icon-path{
  fill : #a43246 !important;
  transition: all 0.3s;
}
.title{
  font-weight: 600;
  white-space: nowrap;
}
.dim-style{
  width: 50%;
}
.line-info{
  min-width: 50%;
}
.nature-info{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.cap-title {
  padding: 7px;
  font-size: 15px;
  font-weight: 600;
  border: 1px solid #e9e9e9f5;
  border-bottom: unset;
  background-color: #ffffff;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
.cap-content{
  padding: 5px;
  border: 1px solid #e9e9e9f5;
  background-color: #ffffff;
  border-radius: 0 0 5px 5px;
}
.cap-sub-title {
  padding: 2px 5px;
  font-weight: 600;
}
.selected-item .icon-path{
  fill : #a43246 !important;
  transition: all 0.3s;
}

</style>